import { render, staticRenderFns } from "./SForm.vue?vue&type=template&id=06934317&"
import script from "./SForm.vue?vue&type=script&lang=js&"
export * from "./SForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports